module.exports = __webpack_public_path__ + "img/icon-alert-white.6c615d2a.svg";